import styled from 'styled-components'
import { Tipografia } from '../../../../components/Tipografia'

export const ItemDetalheControleComissaoPedidoStyles = {
  TipografiaInline: styled(Tipografia)`
    display: inline;
  `
}
